import React, { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { FileManagerCadFileStatus } from '../../../utils/file';
import { Icon } from '../../icon/icon';

type Props = {
  status: FileManagerCadFileStatus;
  onTriggerFileConversion: MouseEventHandler;
  existsInSkyView: boolean;
};

const CadStatusIcon = (props: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  switch (props.status) {
    case 'COMPLETED':
      return props.existsInSkyView ? (
        <Icon
          icon={['fal', 'check']}
          title={t('fileManager.folderListView.cadStatus.completed', { ns: 'components' })}
        />
      ) : null;

    case 'FAILED':
      return (
        <Icon
          color="crimson"
          icon={['fad', 'triangle-exclamation']}
          swapOpacity={true}
          title={t('fileManager.folderListView.cadStatus.failed', { ns: 'components' })}
        />
      );

    case 'RUNNING':
      return (
        <Icon
          icon={['fad', 'spinner']}
          spin={true}
          title={t('fileManager.folderListView.cadStatus.running', { ns: 'components' })}
        />
      );

    case 'NOT_LAND_XML':
      return (
        <Icon
          color={theme.color.blue}
          icon={['fas', 'circle-info']}
          title={t('fileManager.folderListView.cadStatus.notLandXml', { ns: 'components' })}
        />
      );

    case 'RUNNABLE':
      return (
        <Icon
          color={theme.color.blue}
          icon={['fas', 'rotate-right']}
          title={t('fileManager.folderListView.cadStatus.runnable', { ns: 'components' })}
          onClick={props.onTriggerFileConversion}
          onHoverStyle={{ icon: ['fad', 'rotate-right'] }}
        />
      );

    default:
      return null;
  }
};

export { CadStatusIcon, Props as CadStatusIconProps };
